import moment from "moment";
import {Activity} from "../model/Order";

export class DateService {

  public toStartWeek(): Date {
    let now: Date = new Date();
    var diff = now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1);
    return new Date(now.setDate(diff));
  }

  public toEndWeek(): Date {
    let startWeek = this.toStartWeek();
    return new Date(startWeek.setDate(startWeek.getDate() + 6));
  }

  public getCurrentWeek(): ActivityWeek {
    var ts = Math.floor(this.getMonday().getTime() / 8.64e7);

    var w = new ActivityWeek();
    for (var i = 0; i < 7; i++) {
      var ad = new ActivityDate();
      ad.dateStamp = ts++;
      w.activityDates.push(ad);
    }
    return w;
  }

  public getCurrentMonth(): ActivityMonth {
    return new ActivityMonth();
  }

  private getMonday(): Date {
    var d = new Date();
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  /**
   * DST aware method to compute EpochDate
   * @param date
   */
  public dateToEpochDay(date: Date) {
    // Calculate the number of milliseconds per day
    const millisecondsPerDay = 24 * 60 * 60 * 1000;

    console.log(date.getUTCHours())

    // to avoid DST computation we pretend we are pure UTC
    const localYear = date.getFullYear();
    const localMonth = date.getMonth();
    const localDay = date.getDate();

    // Use these components to construct the UTC date
    const utcDate = Date.UTC(localYear, localMonth, localDay);
    const utcEpoch = Date.UTC(1970, 0, 1); // January 1, 1970

    // Calculate the difference in milliseconds and convert to days
    const epochDay = Math.floor((utcDate - utcEpoch) / millisecondsPerDay);
    console.log("epochDay : " + date + ":" + epochDay);
    return epochDay;
  }

  public toDate(referenceDate: number): Date {
    return new Date(referenceDate * 86400 * 1000);
  }

  public getToday(): ActivityDate {
    const d = new Date();
    const ad = new ActivityDate();
    ad.dateStamp = this.dateToEpochDay(d);
    return ad;
  }

  public toTime(d: Date): string {
    return moment(d).locale('fr').format('HH:mm');
    ;
  }

}

export class ActivityWeek {

  activityDates: ActivityDate[] = [];

  public getStartDate(): Date {
    return this.activityDates[0].asDate();
  }

  public getEndDate(): Date {
    let startDate = this.getStartDate();
    return new Date(startDate.setDate(startDate.getDate() + 6));
  }

  addWeek() {
    if (this.activityDates)
      for (let a of this.activityDates)
        a.dateStamp += 7;
  }

  removeWeek() {
    if (this.activityDates)
      for (let a of this.activityDates)
        a.dateStamp -= 7;
  }

  getStartDatetamp(): number {
    return this.activityDates[0].dateStamp;
  }
}

export class ActivityDate {
  dateStamp: number;

  addDay() {
    this.dateStamp++;
  }

  removeDay() {
    this.dateStamp--;
  }

  asDate(): Date {
    let d = new Date(this.dateStamp * (24 * 3600 * 1000));
    return d;
  }


  isWeekEnd(): boolean {
    let d = new Date(this.dateStamp * (24 * 3600 * 1000));
    return d.getDay() == 6 || d.getDay() == 0;
  }


  copyFrom(activityDate: ActivityDate): ActivityDate {
    this.dateStamp = activityDate.dateStamp;
    return this;
  }

  isToday() {
    let d1 = new Date();
    let d2 = this.asDate();
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

  }

  computeLabel(): string {
    return moment(this.asDate()).locale('fr').format('dddd Do MMMM YYYY');
  }

  computeShortLabel(): string {
    return moment(this.asDate()).locale('fr').format('ddd Do MMM YY');
  }

  withTimeStamp(day: number): ActivityDate {
    this.dateStamp = day;
    return this;
  }
}

export class ActivityMonth {

  startDate: Date;
  endDate: Date;
  year: number;
  currentMonth: number;

  constructor() {
    this.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    this.endDate = new Date(new Date().getFullYear(), this.startDate.getMonth() + 1, 0);
    this.currentMonth = this.startDate.getMonth();
    this.year = this.startDate.getFullYear();
  }

  public getStartMonth(): Date {
    return this.startDate;
  }

  public getEndMonth(): Date {
    return this.endDate;
  }

  addMonth() {
    this.startDate = new Date(this.year, this.currentMonth + 1, 1, 8, 0, 0);
    this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0);
    this.currentMonth = this.startDate.getMonth();
    this.year = this.startDate.getFullYear();
  }

  removeMonth() {
    this.startDate = new Date(this.year, this.currentMonth - 1, 1, 8, 0, 0);
    this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth() + 1, 0);
    this.currentMonth = this.startDate.getMonth();
    this.year = this.startDate.getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/services/DateService.ts